<template>
  <div class="container">
    <h1>Estruturas Organizacionais</h1>
    <div class="card">
      <Item class="pr-4" />
    </div>
  </div>
</template>

<script>
import Item from "../components/TreeStructure/Item.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Item },
  computed: {
    ...mapState("organizational_structures", ["tree_structure"]),
  },
  methods: {
    ...mapActions("organizational_structures", ["ActionTreeStructure"]),
  },
  async created() {
    await this.ActionTreeStructure();
  },
};
</script>

<style>
</style>
